import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { isInIframe } from '@shared/utils/isInIframe';

const isPreviewing = isInIframe();

/**
 * Returns true when the full guest site SSR path should be active.
 *
 * Requires all three conditions:
 * - websiteFullySsrGuestSite: FE flag that controls client-side SSR behavior
 * - websiteCharmFullySsrGuestSite: Charm server flag that enables Amplitude variant
 *   hydration during SSR (required for flicker-free feature flag resolution)
 * - NOT in website preview (iframe): The server immediately serves the CSR document
 *   back to the client when ?preview=true, so SSR content is never rendered in
 *   preview mode. Fonts and theme aren't preloaded in preview, so the JoyLogoLoader
 *   gate is still needed there.
 */
export const useIsGuestSiteSsrEnabled = (): boolean => {
  const [isFeEnabled] = useIsFeatureEnabled('websiteFullySsrGuestSite');
  const [isCharmEnabled] = useIsFeatureEnabled('websiteCharmFullySsrGuestSite');
  return !isPreviewing && isFeEnabled && isCharmEnabled;
};
